import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import * as actions from "../../../../store/actions";
import Spinner from './../../../../components/Spinner/index';
import moment from 'moment';
import { i18n } from '../../../../translate/i18n';
import { isEmpty } from 'lodash';

const FormEquipmentsServiceTypes = (props) => {
  const dispatch = useDispatch()

  const equipmentModelLoading = useSelector(state => state.equipments.equipmentModelLoading);
  const equipmentModelCreateEquipment = useSelector(state => state.equipments.equipmentModel);

  const changeDate = (date, service, isValid) => {
    dispatch(actions.setExpirationDateServiceEquipmentsCreateFrom(date, service, isValid));
  }

  const setDeadline = (frequency) => {
    const { type, amount, onDemand } = frequency;
    if (!onDemand) {
      return new Date(moment().add(amount, type).toISOString());
    } else {
      return new Date(moment().toISOString());
    }
  };

  const checkValidDeadline = (frequency, dateSelected) => {
    const { type, amount, onDemand } = frequency;
    if (onDemand) {
      return moment(dateSelected).isBefore(moment().endOf('day'));
    }
    return moment(dateSelected).isBefore(moment().endOf('day').add(amount, type));
  };

  return (
    <div style={styles.container}>
      <div style={{ marginBottom: 10 }}>{i18n.t('divFormEquipServType.text')}</div>
      {equipmentModelLoading && isEmpty(equipmentModelCreateEquipment) &&
        <div style={styles.loadingContainer}>
          <Spinner />
        </div>
      }
      {equipmentModelLoading && !isEmpty(equipmentModelCreateEquipment) &&
        <Spinner overlay />
      }

      {!isEmpty(equipmentModelCreateEquipment) && equipmentModelCreateEquipment.equipmentServices.map(service =>
        !service.frequency.onDemand && <div style={styles.serviceRow} key={service._id}>
          <DatePicker
            label={`${service.serviceType.name} (${service.frequency.name})`}
            margin='normal'
            value={service.expiration && new Date(service.expiration)}
            onChange={date => changeDate(date, service, checkValidDeadline(service.frequency, date))}
            format="dd/MM/yyyy"
            maxDate={setDeadline(service.frequency)}
            invalidDateMessage={i18n.t('keyboardDatePickerFormEquipServType.invalidDateMessage')}
            maxDateMessage={i18n.t('keyboardDatePickerFormEquipServType.maxDateMessage')}
            sx={styles.datepicker}
            slotProps={{ textField: { variant: 'standard', } }}
          />
        </div>
      )}
    </div>
  )
}

const styles = {
  container: {
    padding: 20,
    fontSize: '1rem',
    border: '1px solid grey',
    borderRadius: 20,
    background: "#ececec",
    margin: '1rem 0',
    position: 'relative',
  },
  serviceRow: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  },
  loadingContainer: {
    position: 'relative',
    height: 70,
    background: "#ececec",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  datepicker: {
    width: '80%',
    marginTop: '10px',
  }
}

export default FormEquipmentsServiceTypes;

